import Flex from 'components/ui/Flex';
import ReturnStatusCards from 'components/Header/ReturnStatusCards';
import BatchReturnStatusCards from 'components/batch-returns/BatchReturnStatusCards';
import { BatchReturnStatusType, ReturnStatusType } from 'returnCenter-api';
import { styled } from 'styled-components';
import NavBtn from 'components/ui/NavBtn';
import useAppSelector from 'hooks/useAppSelector';
import { orderSelectors } from 'store/reducers/orderSlice';
import { returnSelectors } from 'store/reducers/returnSlice';
import { useTranslation } from 'react-i18next';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';

import useGoHome from 'hooks/useGoHome';
import { ContentContainer } from 'components/ui/ContentContainer';
import { selectViewMode, selectSelectedBatchStatus } from 'store/reducers/navigationSlice';
import { selectBatchReturnStatistics, selectBatchLoadingCards } from 'store/reducers/batchReturnSlice';

type ActionsBarProps = {
    statistics: any;
    completed: boolean;
    blocked: boolean;
    inprogress: boolean;
    created: boolean;
    itemsSelected: boolean;
    incomingPackage: boolean;
    received: boolean;
    creditError: boolean;
    creditedBatchPending: boolean;
    selectedStatus: ReturnStatusType | null;
    onStatusCardClick: (statusType?: ReturnStatusType, value?: number) => void;
    onBatchStatusCardClick: (statusType: BatchReturnStatusType, value?: number) => void;
    handleBack: () => void;
    isHome: boolean;
    isReturnHome: boolean;
};

const ActionsBar = ({
    statistics,
    completed,
    blocked,
    inprogress,
    created,
    itemsSelected,
    incomingPackage,
    received,
    creditError,
    creditedBatchPending,
    selectedStatus,
    onStatusCardClick,
    onBatchStatusCardClick,
    handleBack,
    isHome,
    isReturnHome,
}: ActionsBarProps) => {
    const { t } = useTranslation();

    const orderError = useAppSelector(orderSelectors.selectOrderErrorOnLoading);
    const returnSlipError = useAppSelector(returnSelectors.selectReturnSlipErrorOnLoading);
    const viewMode = useAppSelector(selectViewMode);
    const batchStatistics = useAppSelector(selectBatchReturnStatistics);
    const batchLoadingCards = useAppSelector(selectBatchLoadingCards);
    const selectedBatchStatus = useAppSelector(selectSelectedBatchStatus);

    const handleGoHome = useGoHome();

    const hasError = orderError || returnSlipError;

    return (
        <ActionsContainer className="actions-container" $grow={1} align="center">
            <ContentContainer column>
                <StatusCardContainer $grow={1} justify="center">
                    {viewMode === 'returns' ? (
                        <ReturnStatusCards
                            statistics={statistics}
                            completed={completed}
                            blocked={blocked}
                            inprogress={inprogress}
                            created={created}
                            itemsSelected={itemsSelected}
                            incomingPackage={incomingPackage}
                            received={received}
                            creditError={creditError}
                            creditedBatchPending={creditedBatchPending}
                            selectedStatus={selectedStatus}
                            handleClick={onStatusCardClick}
                        />
                    ) : (
                        <BatchReturnStatusCards
                            statistics={batchStatistics}
                            loadingCards={batchLoadingCards}
                            selectedStatus={selectedBatchStatus}
                            handleClick={onBatchStatusCardClick}
                        />
                    )}
                </StatusCardContainer>
                {(!isHome || hasError) && (
                    <NavBtnContainer
                        gap="1rem"
                        justify="between"
                        align="center"
                        className="nav-btn-container w-100"
                        $grow={1}
                    >
                        <NavBtn onClick={handleBack} icon={faArrowLeft} label={t('back')} disabled={isReturnHome} />
                        <NavBtn onClick={handleGoHome} icon={faSearch} label={t('newReturn')} main />
                    </NavBtnContainer>
                )}
            </ContentContainer>
        </ActionsContainer>
    );
};

export default ActionsBar;

const ActionsContainer = styled(Flex)`
    margin-top: 1rem;
    background-color: ${({ theme }) => theme.colors.fillWhite};
    padding: 0 1rem 1rem 1rem;

    @media (max-width: 832px) {
        flex-direction: column-reverse;
        justify-content: center;
        gap: 1rem;
    }
`;

const StatusCardContainer = styled(Flex)`
    width: 100%;
    padding-top: 1rem;
    flex-wrap: wrap;

    @media (max-width: 1100px) {
        /* justify-content: end; */
    }
    @media (max-width: 832px) {
        justify-content: center;
    }
`;

const NavBtnContainer = styled(Flex)`
    border-top: 1px solid ${({ theme }) => theme.colors.borderLight};
    padding-top: 1rem;
    margin-top: 1rem;
    width: 100%;
`;
